/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState } from 'react';
import './index.css';
import { Container } from 'react-bootstrap';
import parse from 'html-react-parser';

const FAQ = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Container>
      <section className="faq-section">
        <div className="faq-container">
          <h2 className="faq-title">{data.title ? parse(data.title) : 'Frequently Asked Questions'}</h2>
          <div className="faq-accordion">
            {data.questions.map((item, index) => (
              <div 
                key={index} 
                className={`faq-item ${activeIndex === index ? 'active' : ''} ${index % 2 === 0 ? 'odd' : 'even'}`}
              >
                <div 
                  className="faq-question" 
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="faq-left-border"></div>
                  <span className="faq-number">{item.questionNumber || index + 1}.</span>
                  <h3 className="faq-question-text">{parse(item.question)}</h3>
                  <span className="faq-toggle-icon">
                    {activeIndex === index ? <span className="up-arrow">&gt;</span> : <span className="down-arrow">&gt;</span>}
                  </span>
                  <div className="faq-right-square"></div>
                </div>
                {activeIndex === index && (
                  <div className="faq-answer">
                    <div className="faq-answer-content">
                      {parse(item.answer)}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </Container>
  );
};

export default FAQ;